const normalizeCategoriaName = (value) =>
  String(value || "")
    .trim()
    .toLocaleLowerCase("es-MX");

const specialCategoriaRank = (categoria) => {
  const name = normalizeCategoriaName(categoria?.nombre ?? categoria?.label);
  if (name === "otro") return 1;
  return 0;
};

export function sortCategoriasForDisplay(categorias = []) {
  return [...categorias].sort((a, b) => {
    const rankDiff = specialCategoriaRank(a) - specialCategoriaRank(b);
    if (rankDiff !== 0) return rankDiff;
    return normalizeCategoriaName(a?.nombre ?? a?.label).localeCompare(
      normalizeCategoriaName(b?.nombre ?? b?.label),
      "es-MX"
    );
  });
}
